<div class="fixed inset-0 w-full h-full z-[100] bg-opacity-60 bg-black flex justify-center items-center">
    <app-loading-icon></app-loading-icon>
</div>